<template>
  <div class="main-card mb-3 card">
    <div class="card-body">
      <h5 class="card-title">Real-time Data Server</h5>
      <table class="mb-0 table table-bordered">
        <tbody>
          <tr>
            <td width="15%">Current Server Time</td>
            <td width="55%">
              <span id="stime">{{ data?.server_time || '-' }}</span>
            </td>
            <td width="15%">Server Uptime</td>
            <td width="15%" colspan="3">
              <span id="uptime">{{ data?.server_uptime || '-' }}</span>
            </td>
          </tr>
          <tr>
            <td width="15%">CPU Model [{{ data?.cpu_model_num || '-' }}Core]</td>
            <td width="85%" colspan="5">
              {{ data?.cpu_model || '-' }}
            </td>
          </tr>
          <tr>
            <td>CPU usage</td>
            <td colspan="3">
              <div class="d-flex flex-wrap">
                <span v-for="(usage, index) in data?.cpu_usage" :key="index" style="width: 60px; text-align: center; text-transform: uppercase">
                  {{ index }}<br />
                  <span :class="`text-${this.rateColor(usage)}`">{{ usage }}%</span>
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Space usage</td>
            <td colspan="5">
              Total Space {{ data?.total_space || '-' }}G&nbsp; Used {{ data?.used_space || '-' }}G&nbsp; Free {{ data?.free_space || '-' }}G&nbsp; Rate {{ this.ratePercent(data?.used_space, data?.total_space) }}%
              <div class="progress-bar-sm progress-bar-animated-alt progress">
                <div :class="`progress-bar bg-${this.rateColor(this.ratePercent(data?.used_space, data?.total_space))}`" :style="`width:${this.ratePercent(data?.used_space, data?.total_space)}%`"></div>
              </div>
            </td>
          </tr>
          <tr>
            <td>Memory usage</td>
            <td colspan="5">
              <div class="mb-2">
                Total Memory {{ data?.memory_total || '-' }}{{ data?.memory_unit || '' }}&nbsp; Used {{ data?.memory_used || '-' }}{{ data?.memory_unit || '' }}&nbsp; Free {{ data?.memory_free || '-' }}{{ data?.memory_unit || '' }}&nbsp; Rate {{ this.ratePercent(data?.memory_used, data?.memory_total) }}%&nbsp;
                <div class="progress-bar-sm progress-bar-animated-alt progress">
                  <div :class="`progress-bar bg-${this.rateColor(this.ratePercent(data?.memory_used, data?.memory_total))}`" :style="`width:${this.ratePercent(data?.memory_used, data?.memory_total)}%`"></div>
                </div>
              </div>
              <div class="mb-2">
                Cache Memory {{ data?.memory_cached || '-' }}{{ data?.memory_unit || '' }}&nbsp; Rate {{ this.ratePercent(data?.memory_cached, data?.memory_total) }}%&nbsp; Buffers {{ data?.memory_buffer || '-' }}{{ data?.memory_unit || '' }}&nbsp;
                <div class="progress-bar-sm progress-bar-animated-alt progress">
                  <div :class="`progress-bar bg-${this.rateColor(this.ratePercent(data?.memory_cached, data?.memory_total))}`" :style="`width:${this.ratePercent(data?.memory_cached, data?.memory_total)}%`"></div>
                </div>
              </div>
              <div class="mb-2">
                Real Memory Used {{ data?.memory_real_used || '-' }}{{ data?.memory_unit || '' }}&nbsp; Real Memory Free {{ data?.memory_real_free || '-' }}{{ data?.memory_unit || '' }}&nbsp; Rate {{ this.ratePercent(data?.memory_real_used, data?.memory_total) }}%&nbsp;
                <div class="progress-bar-sm progress-bar-animated-alt progress">
                  <div :class="`progress-bar bg-${this.rateColor(this.ratePercent(data?.memory_real_used, data?.memory_total))}`" :style="`width:${this.ratePercent(data?.memory_real_used, data?.memory_total)}%`"></div>
                </div>
              </div>
              <div class="mb-2">
                SWAP {{ data?.swap_total || '-' }}{{ data?.memory_unit || '' }}&nbsp; Used {{ data?.swap_used || '-' }}{{ data?.memory_unit || '' }}&nbsp; Free {{ data?.swap_free || '-' }}{{ data?.memory_unit || '' }}&nbsp; Rate {{ this.ratePercent(data?.swap_used, data?.swap_total) }}%&nbsp;
                <div class="progress-bar-sm progress-bar-animated-alt progress">
                  <div :class="`progress-bar bg-${this.rateColor(this.ratePercent(data?.swap_free, data?.swap_total))}`" :style="`width:${this.ratePercent(data?.swap_free, data?.swap_total)}%`"></div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>Average System Load</td>
            <td colspan="5" class="w_number">
              <span id="loadAvg">{{ data?.load_avg }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return this.config
    }
  },
  methods: {
    ratePercent(a, b) {
      if (parseInt(b) == 0 || isNaN(parseInt(b))) {
        return 0
      }
      return Math.round((parseFloat(a) * 10000) / parseFloat(b)) / 100
    },
    rateColor(percent) {
      if (percent <= 25) {
        return 'primary'
      } else if (percent <= 50) {
        return 'success'
      } else if (percent <= 75) {
        return 'warning'
      } else {
        return 'danger'
      }
    }
  },
  props: {
    config: Object
  }
}
</script>
